(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    //Aquí defino los 3 estados: abstracto, edicion list y edicion details
    /* @ngInject */
    function stateConfig($stateProvider, NG_LIST_DEFAULT_PARAMS_PUBLIC) {
        $stateProvider.state('buscador', {
            parent: 'public',
            url: '/ediciones',
            redirectTo: 'buscador/basico',
            data: {
                authorities: []
            },
            resolve: {
                ediciones: function () {
                    return {};
                }
            }
            //  Estado en el buscador básico
        }).state('buscador/basico', {
            parent: 'buscador',
            url: '/buscador-basico/p/:page',
            data: {
                pageTitle: 'edicionList.title'
            },
            params: {
                page: {value: '1', dynamic: true},
                filter: {
                    sortProperty: 'autor',
                    sortDirection: 'ASC',
                    size: NG_LIST_DEFAULT_PARAMS_PUBLIC.size
                }
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/edicion/buscador.basico.edicion.html',
                    controller: 'BuscadorController',
                    controllerAs: 'ctrl'
                }
            }

            //ESTADO En el buscador avanzado
        }).state('buscador/avanzado', {
            parent: 'buscador',
            url: '/buscador-avanzado/p/:page',
            data: {
                pageTitle: 'edicionList.title'
            },
            params: {
                page: {value: '1', dynamic: true},
                filter: {
                    sortProperty: 'autor',
                    sortDirection: 'ASC',
                    size: NG_LIST_DEFAULT_PARAMS_PUBLIC.size
                }
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/edicion/buscador.avanzado.edicion.html',
                    controller: 'BuscadorController',
                    controllerAs: 'ctrl'
                }
            },
            // Listar
            resolve: {
                /* @ngInject */
                tipologias: function (Tipologia) {
                    return Tipologia.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                        return data.content;
                    });
                },
                /* @ngInject */
                subgeneros: function (Subgenero) {
                    return Subgenero.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                        return data.content;
                    });
                },
                /* @ngInject */
                modalidades: function (EnumService) {
                    return EnumService.get("modalidaddiscurso");
                },
                /* @ngInject */
                tamanos: function (EnumService) {
                    return EnumService.get("tamano");
                }
            }

            //ESTADO DETAILS
        }).state('edicionDetails', {
            parent: 'buscador',

            url: '/BDRS:bdrs/:edicionId',
            data: {
                pageTitle: 'edicionDetails.title'
            },
            params: {
                relacionId: 'relacionId'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/edicion/edicion.details.html',
                    controller: 'EdicionDetailsController',
                    controllerAs: 'ctrlDetails'
                }
            },
            // Listar
            resolve: {
                /* @ngInject */
                edicion: function (Edicion, $stateParams) {
                    return Edicion.publicGet({id: $stateParams.edicionId}).$promise.then(function (data) {
                        return data;
                    });
                },
                /* @ngInject */
                ejemplares: function (Ejemplar, $stateParams) {
                    return Ejemplar.findEjemplaresDTOByEdicion({id: $stateParams.edicionId}).$promise.then(function (data) {
                        return data;
                    });
                },
                /* @ngInject */
                edicionesHermanas: function (Edicion, $stateParams) {
                    return Edicion.findByRelacion({
                        edicionId: $stateParams.edicionId,
                        bdrs: $stateParams.bdrs
                    }).$promise.then(function (data) {
                        return data;
                    });
                }
            }
        });
    }
})();

